module.exports = __webpack_public_path__ + "static/media/trailer.4d11d894.mp4";